import React from "react";
import './Statics.css'
import { Analiytic } from '../../assests/images'
export default function Statics() {

  const data = [{ 'title': 'Solutions Delivered', 'num': '500+' },
  { 'title': 'Years of Experience', 'num': '23+' },
  { 'title': 'Employee & Associates', 'num': '50+' },
  { 'title': ' Satisfied Clients', 'num': '97%' },
  ]

  return (
    <div className="statics__main__container">
      <div className="statics__container">
        <div className="statics__title">
          <div className="square">

          </div>
          <p className="statics__heading heading1">Why Us ?</p>
          <p className="statics__subheading">We understand how hard it is to convert ideas into industry-leading products. With years of expertise in helping companies take off, we’re happy to help you get to profitability under record time.</p>
        </div>
        <div className="statics__stat">
          <img src={Analiytic}></img>
          <div className="statics__list">
            {
              data.map((item) => {
                return (
                  <div className="statics__listitem">
                    <p>{item.num}</p>
                    <p>{item.title}</p>
                  </div>
                )
              })
            }

          </div>
        </div>

      </div>
    </div>

  )
}